const personFieldProperties = ['ONLY_MYSELF', 'DIRECT_SUBORDINATE', 'SUBORDINATE', 'DIRECT_LEAD', 'LEAD'] // 当前登录人.本人|直属下级|下级|直属上级|上级
const dateFieldProperties = ['PAST_IN_N_DAY', 'NEXT_IN_N_DAY', 'PAST_ON_N_DAY', 'NEXT_ON_N_DAY', 'GT_N_DAY', 'LT_N_DAY'] // 过去N天|未来N天|过去第N天|未来第N天|晚于N天以后|早于N天以前
const departmentFieldProperties = ['OWN_DEPARTMENT', 'OWN_DIRECT_SUB_DEP', 'OWN_SUB_DEP', 'OWN_SUB_LEAD_DEP', 'OWN_LEAD_DEP'] // 当前登录人 默认部门|直属上级.部门|上级.部门|直接下属.部门|下属.部门
/*
    BELONG("BELONG", "属于", -1),
    NBELONG("NBELONG", "不属于", -1),
    LIKE("LIKE", "包含", -1),
    NLIKE("NLIKE", "不包含", -1),
    EQ("EQ", "等于", -1),
    NEQ("NEQ", "不等于", -1),
    IS("IS", "为空", -1),
    ISN("ISN", "不为空", -1),
    GT("GT", "大于", -1),
    GTE("GTE", "大于等于", -1),
    LT("LT", "小于", -1),
    LTE("LTE", "小于等于", -1),
    BETWEEN("BETWEEN", "介于", -1),
    EAT("EAT", "早于", -1),
    LAT("LAT", "晚于", -1),

    ONLY_MYSELF("ONLY_MYSELF", "当前登录人.本人", 0),
    DIRECT_SUBORDINATE("DIRECT_SUBORDINATE", "当前登录人.直属下级", 1),
    SUBORDINATE("SUBORDINATE", "当前登录人.下级", 2),
    DIRECT_LEAD("DIRECT_LEAD", "当前登录人.直属上级", 3),
    LEAD("LEAD", "当前登录人.上级", 4),

    OWN_DEPARTMENT("OWN_DEPARTMENT", "当前登录人.默认部门", 5),
    OWN_DIRECT_SUB_DEP("OWN_DIRECT_SUB_DEP", "当前登录人.直属上级.部门", 6),
    OWN_SUB_DEP("OWN_SUB_DEP", "当前登录人.上级.部门", 7),
    OWN_SUB_LEAD_DEP("OWN_SUB_LEAD_DEP", "当前登录人.直接下属.部门", 8),
    OWN_LEAD_DEP("OWN_LEAD_DEP", "当前登录人.下属.部门", 9),

    PAST_IN_N_DAY("PAST_IN_N_DAY", "过去N天", -1),
    NEXT_IN_N_DAY("NEXT_IN_N_DAY", "未来N天", -1),
    PAST_ON_N_DAY("PAST_ON_N_DAY", "过去第N天", -1),
    NEXT_ON_N_DAY("NEXT_ON_N_DAY", "未来第N天", -1),

    OR("OR", "查询条件“或”", -1),
    SPECIAL_SQL("SPECIAL_SQL", "特殊查询SQL", -1),
  */
const allRelationType = {
  'BELONG': 1,
  'NBELONG': 1,
  'LIKE': 2,
  'NLIKE': 2,
  'EQ': 3,
  'NEQ': 3,        
  'GT': 3,
  'GTE': 3,
  'LT': 3,
  'LTE': 3,
  'IS': 4,
  'ISN': 4,
  'BETWEEN': 5,
  'EAT': 6,
  'LAT': 6,
  'ONLY_MYSELF': 7,
  'DIRECT_SUBORDINATE': 7,
  'SUBORDINATE': 7,
  'DIRECT_LEAD': 7,
  'LEAD': 7,
  'OWN_DEPARTMENT': 8,
  'OWN_DIRECT_SUB_DEP': 8,
  'OWN_SUB_DEP': 8,
  'OWN_SUB_LEAD_DEP': 8,
  'OWN_LEAD_DEP': 8,
  'PAST_IN_N_DAY': 9,
  'NEXT_IN_N_DAY': 9,
  'PAST_ON_N_DAY': 9,
  'NEXT_ON_N_DAY': 9,
  'OR': 10,
  'SPECIAL_SQL': 10,
  'GT_N_DAY': 11,
  'LT_N_DAY': 11,
}

const filter = {
  namespaced: true,
  state: {
    allRelationType,
    personFieldProperties,
    dateFieldProperties,
    departmentFieldProperties, 
    hiddenRelationFields: ['IS', 'ISN'].concat(personFieldProperties, departmentFieldProperties),
    hiddenRelationEmptyFields: ['IS', 'ISN', ''].concat(personFieldProperties, departmentFieldProperties)
  },
  mutations: {

  }
}
export default filter
